import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, destructive, success, warningDark, white } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	healthScoreCircle: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 36,
		height: 36,
		borderRadius: '50%',
		fontSize: 13,
		fontWeight: 700,
		color: white,
		marginLeft: 30,
		alignSelf: 'flex-start',
		flexShrink: 0,
	},
	healthScoreGreen: {
		backgroundColor: success,
	},
	healthScoreOrange: {
		backgroundColor: warningDark,
	},
	healthScoreRed: {
		backgroundColor: destructive,
	},
	healthScoreNA: {
		backgroundColor: darkGrayFontColor,
		fontSize: 11,
	},
});
